import React, {useEffect, useState} from 'react';
import {JsonApiClient} from "@drupal-api-client/json-api-client";
import Config from "../../utils/Config";
import {Jsona} from "jsona";
import {DrupalJsonApiParams} from 'drupal-jsonapi-params';
import Box from "@mui/material/Box";
import Moment from 'react-moment';

const client = new JsonApiClient(Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl'), {
  serializer: new Jsona()
});

export interface IDateRange {
  value: string;
  end_value: string;
}

export interface ITerm {
  machine_name?: string;
  name: string;
  status: boolean;
  id: string;
}

export interface IRichText {
  format: string;
  value: string;
  processed: string;
}

export interface IEvent {
  label: string;
  description: IRichText;
  event_date: IDateRange;
  event_type: ITerm;
  highlight: boolean;
  id: string;
}

export interface IEventListProps {
  eventTypes: string[]
}

const EventList = (props: IEventListProps) => {
  const [events, setEvents] = useState<IEvent[]>([]);

  const getEvents = async () => {
    const datastr = new Date().toISOString();
    const apiParams = new DrupalJsonApiParams();
    apiParams
      .addGroup('eventdate', 'OR')
      .addFilter('event_date.value', datastr, '>=', 'eventdate')
      .addFilter('event_date.end_value', datastr, '>=', 'eventdate')
      .addFilter('status', '1')
      .addInclude(['event_type'])
      .addSort('event_date.value');
    if (props.eventTypes.length > 0) {
      apiParams.addGroup('eventType', 'OR')
        .addFilter('event_type.machine_name', props.eventTypes, 'IN', 'eventType')
        .addFilter('event_type.machine_name', null, 'IS NULL', 'eventType');
    }
    const urlencodedQueryString = apiParams.getQueryString();
    const queryString = apiParams.getQueryString({encode: false});

    let jsonApiEvents = await client.getCollection("event--event", {
      queryString: queryString,//"filter[event_date.value]>"+datastr+"&sort=event_date.value",
    }) as any;

    console.log('events:', jsonApiEvents);
    setEvents(jsonApiEvents);
  };

  useEffect(() => {
    getEvents();
  }, []);

  return (
    <section className="bg-jaggedice-100 p-5 rounded-lg">
      <div
        className="text-center relative  text-center  font-heading text-4xl md:text-5xl font-extrabold text-blue-900 mb-6">
        <span className="bg-[linear-gradient(to_bottom,transparent_65%,#FDCEDB_65%)]
                     bg-no-repeat bg-[length:100%_80%] bg-[position:0_10%] px-1">
          Termine
        </span>
      </div>
      <div className="bg-white px-5 rounded-3xl">
        <ol
          className="relative border-s py-5 border-gray-200 dark:border-gray-700">
          {events?.map((item, i) =>
            <li className="my-6 ms-4" key={item.id}>
              <div
                className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>

              <div
                className="mb-1 text-sm font-normal leading-none text-gray-600 dark:text-gray-500">
                  <Moment format="DD.MM.YYYY" parse="YYYY-MM-DDTHH:mm:ss">
                    {item.event_date.value}
                  </Moment>
                  {item.event_date.end_value && (
                    <>
                      &nbsp;-&nbsp;<Moment format="DD.MM.YYYY"
                                           parse="YYYY-MM-DDTHH:mm:ss">
                      {item.event_date.end_value}
                    </Moment>
                    </>
                  )}
                {item.event_type && item.event_type.name == 'Altkloster' && (
                  <span
                    className="bg-altkloster-100 text-altkloster-700 text-xs   px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300 ms-3">{item.event_type.name}</span>
                )}
                {item.event_type && item.event_type.name == 'Hedendorf' && (
                  <span
                    className="bg-hedendorf-100 text-hedendorf-700 text-xs   px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300 ms-3">{item.event_type.name}</span>
                )}

              </div>
              <div className="text-lg font-semibold font-heading text-gray-900 dark:text-white mt-2">
                { item.highlight == true && (
                  <div className="inline bg-[linear-gradient(to_bottom,transparent_65%,#f5ff00BB_15%)]
                     bg-no-repeat bg-[length:100%_90%] bg-[position:0_5%] px-1">{item.label}</div>
                )}
                { item.highlight != true && (
                  <>{item.label}</>
                )}
              </div>
                <div
                  className="text-base font-normal text-gray-100">
                  <Box className="prose max-w-[800px]"
                       dangerouslySetInnerHTML={{
                       __html: item.description?.processed.toString().replaceAll("<p>&nbsp;</p>", "") ?? ""
                     }}
                ></Box></div>
            </li>
          )}
        </ol>
      </div>
    </section>
  );
};

export default EventList;
